<template>
    <div id="app">
        <navbar />
        <router-view />
        <footers />
    </div>
</template>

<script>
    import Navbar from '@/components/Navbar'
    import Footers from '@/components/Footers'
    export default {
        name: 'App',
        components: {
            Navbar,
            Footers
        }
    }
</script>

<style>
@font-face {
    font-family: 'Roboto';
    src: url('~@/assets/fonts/Roboto/Roboto-Light.ttf');
    font-weight: 300;
}

@font-face {
    font-family: 'Roboto';
    src: url('~@/assets/fonts/Roboto/Roboto-Regular.ttf');
    font-weight: 400;
}

@font-face {
    font-family: 'Roboto';
    src: url('~@/assets/fonts/Roboto/Roboto-Medium.ttf');
    font-weight: 500;
}

body {
    font-family: 'Roboto', sans-serif;
}

</style>
